import { HotelProvider, HotelSearched } from '@hotels/hotel-results/entities/hotel-searched';

export type HotelDetailResponse = Readonly<{
  Info: HotelInfoDetail;
  Result: HotelSearched;
  SearchId: string;
}>;

export type HotelInfoDetail = Readonly<{
  Address: string;
  Ammenities: string[];
  AmmenityCodes?: string[];
  Badges?: Badges[];
  Category: number;
  Email?: string;
  FullAddress?: string;
  GoodToKnow?: GoodToKnow[];
  Headline?: Headline;
  HotelCode: string;
  HotelName: string;
  HotelProvider?: HotelProvider;
  HotelTypeList?: string[];
  Images: string[];
  Latitude: number;
  LongDescription: string;
  Longitude: number;
  MetaReviews?: MetaReviews[];
  Phone: string;
  PopularWith?: PopularWithType;
  Ratings?: Ratings;
  ReviewsCount?: number;
  ReviewsDistribution?: ReviewsDistribution[];
  ShortDescription: string;
  Stars?: unknown;
  Thumbnail?: string;
  Zone?: string;
}>;

export type HotelAmenity = Readonly<{
  Code: string;
  Name: string;
  Icon?: string;
  Highlight?: boolean;
}>;

export type HotelLowestPrice = Readonly<{
  CurrencyCode: string;
  Price: number;
}>;

export type Badges = Readonly<{
  CategoryName: string;
  Id: number;
  Locale: string;
  ProviderName: string;
  RTHotelId: number;
  SubText: string;
  Text: string;
  TopNPercent: string;
}>;

export type GoodToKnow = Readonly<{
  Id: number;
  Locale: string;
  ProviderName: string;
  RTHotelId: number;
  Score: string;
  Sentiment: string;
  Text: string;
}>;

export type Headline = Readonly<{
  CreatedAt: string;
  InformationType: {Id: number, Name: string};
  InformationTypeId: number;
  Locale: string;
  Order: number;
  RTHotelId: number;
  UpdatedAt: string;
  Value: string;
}>;

export type MetaReviews = Readonly<{
  CategoryName: string;
  EvaluationCount: number;
  Score: number;
  Sentiment: SentimentType;
  ShortText: string;
  SubCategories: MetaReviewsSubCategories[];
  Text: string;
  TravelerType: string;
}>;

export type MetaReviewsSubCategories = Readonly<{
  EvaluationCount: number;
  Score: number;
  Sentiment: SentimentType;
  ShortText: string;
  Text: string;
}>;

export type Ratings = Readonly<{
  Score: number;
  ScoreDescription: string;
  ScoreOutOf: number;
}>;

export type ReviewsDistribution = Readonly<{
  EvaluationCount: number;
  Stars: number;
}>;

export const BreakfastNotIncluded = ['EP', 'RO', 'OTH', 'ZZ'];
export const BoardCodeNotProvider = 'OTH';

export enum RefundableType {
  NonRefundable = 'NonRefundable'
}

export enum PopularWithType {
  Couple = 'couple',
  Business = 'business',
  Solo = 'solo',
  Family = 'family',
  Friends = 'friends'
}

export enum SentimentType {
  Pos = 'pos',
  Neg = 'neg',
  Neu = 'neu'
}
